import { render } from "./SystemResetView.vue?vue&type=template&id=ba4de47c&scoped=true&ts=true"
import script from "./SystemResetView.vue?vue&type=script&lang=ts"
export * from "./SystemResetView.vue?vue&type=script&lang=ts"

import "./SystemResetView.vue?vue&type=style&index=0&id=ba4de47c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4de47c"]])

export default __exports__